import React, { useState } from "react";
import {
  FaMobileAlt,
  FaCogs,
  FaUsers,
  FaCalendarAlt,
  FaClock,
  FaMapMarkerAlt,
  FaArrowRight,
} from "react-icons/fa";

const programmes = [
  {
    id: 1,
    title: "IMDG Programme",
    subtitle: "Dangerous Goods Transportation by Sea",
    date: "16/09/2024 - 18/09/2024",
    time: "09:30 AM - 05:30 PM IST",
    location: "Chennai, 3-star Hotel",
    image: "/images/imdg.png",
    tagline: "Moving Hazmat Safely",
    points: [
      "Introduction to the Regulations Structure",
      "Navigating the IMDG Code",
      "Packaging, Marking, Labeling, and Placarding",
      "Documentation Requirements",
      "Shipment Verification for Compliance",
    ],
  },
  {
    id: 2,
    title: "Linde Programme",
    subtitle: "Safety & Handling Workshop",
    date: "25/10/2024 - 27/10/2024",
    time: "10:00 AM - 05:00 PM",
    location: "Bangalore",
    image: "/images/linde-training.jpg",
    tagline: "Powering Safe Operations",
    points: [
      "Safety Awareness",
      "Equipment Handling",
      "Emergency Procedures",
      "Compliance Standards",
    ],
  },
  {
    id: 3,
    title: "Forklift Training",
    subtitle: "Efficient Material Handling",
    date: "05/11/2024 - 06/11/2024",
    time: "09:00 AM - 04:00 PM",
    location: "Hyderabad",
    image: "/images/forklift-training.jpg",
    tagline: "Drive with Confidence",
    points: [
      "Forklift Basics",
      "Safe Driving Techniques",
      "Load Management",
      "Workplace Safety Rules",
    ],
  },
];

export default function Programmes() {
  const [selected, setSelected] = useState(programmes[0]);

  return (
    <section className="bg-gray-50 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Background with Title + Cards */}
        <div className="relative">
          {/* Background */}
          <div
            className=" bg-indigo-100  h-80 rounded-2xl flex flex-col items-center justify-start pt-12 px-6"   >
            {/* Title inside background */}
            <h1 className="text-4xl md:text-5xl font-bold text-white leading-tight text-center" style={{ color: 'rgb(93, 76, 207)' }}>
              Our Programmes
            </h1>

            <p className="mt-6 text-lg text-black-100 max-w-3xl text-center">
              Gain essential skills and knowledge through our industry-relevant
              courses, designed to elevate performance and ensure long-term
              success in your field.
            </p>
          </div>

          {/* Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 -mt-20 px-4 md:px-8 relative z-10">
            {programmes.map((prog, index) => (
              <div
                key={prog.id}
                onClick={() => setSelected(prog)}
                className={`bg-white rounded-xl shadow-lg p-6 text-center cursor-pointer transition-all duration-300 transform hover:-translate-y-2 ${
                  selected?.id === prog.id
                    ? "ring-4 ring-indigo-500 ring-opacity-70 shadow-xl"
                    : "border border-gray-100 hover:shadow-xl"
                }`}
              >
                <div className="flex justify-center -mt-12 mb-4">
                  <span className="bg-gradient-to-br from-indigo-600 to-purple-600 text-white p-4 rounded-xl shadow-lg">
                    {index === 0 && <FaMobileAlt size={28} />}
                    {index === 1 && <FaCogs size={28} />}
                    {index === 2 && <FaUsers size={28} />}
                  </span>
                </div>
                <h3 className="text-xl font-bold text-gray-900">{prog.title}</h3>
                <p className="text-gray-600 text-sm mt-2">{prog.subtitle}</p>
                <button className="mt-5 text-sm font-semibold text-indigo-600 hover:text-indigo-800 flex items-center justify-center gap-2 mx-auto">
                  MORE <FaArrowRight size={12} />
                </button>
              </div>
            ))}
          </div>
        </div>

        {/* Highlighted Programme Details */}
        {selected && (
          <div className="mt-20 grid md:grid-cols-2 gap-12 items-center">
            {/* Two-layer image design */}
            <div className="relative flex items-center justify-center">
              {/* First layer: background color div with increased height and more left offset */}
              <div className="w-80 h-96 bg-indigo-100 from-indigo-400/70 to-purple-400/70 rounded-2xl absolute -left-1 -top-6 z-0"></div>
              
              {/* Second layer: image slightly offset to right and top */}
              <div className="relative z-10 transform transition-all duration-700 hover:-translate-y-3 ml-4 mt-4">
                <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                  <img
                    src={selected.image}
                    alt={selected.title}
                    className="w-full max-w-md rounded-2xl transition-transform duration-700 hover:scale-105"
                  />
                  {/* Gradient overlay */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent rounded-2xl"></div>
                  
                  {/* Decorative corner elements */}
                  <div className="absolute top-0 left-0 w-16 h-16 border-t-4 border-l-4 border-indigo-500 rounded-tl-2xl"></div>
                  <div className="absolute bottom-0 right-0 w-16 h-16 border-b-4 border-r-4 border-purple-500 rounded-br-2xl"></div>
                </div>
                
                {/* Floating tag */}
                <div className="absolute -bottom-4 -right-4 bg-white px-4 py-2 rounded-lg shadow-lg">
                  <span className="text-sm font-bold text-indigo-600">Featured Programme</span>
                </div>
              </div>
            </div>

            {/* Content */}
            <div className="space-y-6">
              <div>
                <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
                  {selected.title}
                </h2>
                <div className="h-1 w-16 bg-gradient-to-r from-indigo-500 to-purple-500 my-4 rounded-full"></div>
                <p className="text-lg text-gray-600 font-medium">
                  {selected.subtitle}
                </p>
              </div>
              
              {/* Details */}
              <div className="space-y-4 text-gray-700">
                <div className="flex items-center gap-4 p-3 bg-gray-50 rounded-lg">
                  <div className="bg-indigo-100 p-2 rounded-lg">
                    <FaCalendarAlt className="text-indigo-600" size={18} />
                  </div>
                  <span className="font-medium">{selected.date}</span>
                </div>
                <div className="flex items-center gap-4 p-3 bg-gray-50 rounded-lg">
                  <div className="bg-indigo-100 p-2 rounded-lg">
                    <FaClock className="text-indigo-600" size={18} />
                  </div>
                  <span className="font-medium">{selected.time}</span>
                </div>
                <div className="flex items-center gap-4 p-3 bg-gray-50 rounded-lg">
                  <div className="bg-indigo-100 p-2 rounded-lg">
                    <FaMapMarkerAlt className="text-indigo-600" size={18} />
                  </div>
                  <span className="font-medium">{selected.location}</span>
                </div>
              </div>
 
              {/* Points */}
              <div className="pt-4">
                <h3 className="text-lg font-semibold text-gray-900 mb-3">What You'll Learn:</h3>
                <ul className="space-y-2">
                  {selected.points.map((pt, i) => (
                    <li key={i} className="flex items-start">
                      <div className="bg-indigo-100 p-1 rounded-full mr-3 mt-1">
                        <div className="w-2 h-2 bg-indigo-600 rounded-full"></div>
                      </div>
                      <span className="text-gray-700">{pt}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Tagline */}
              <blockquote className="text-xl italic font-semibold text-indigo-700 mt-6 p-4 border-l-4 border-indigo-500 bg-indigo-50 rounded-r-lg">
                "{selected.tagline}"
              </blockquote>

              {/* CTA */}
              <button className="mt-6 bg-gradient-to-r from-indigo-600 to-purple-600 text-white px-8 py-3.5 rounded-lg shadow-md hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1 font-medium flex items-center gap-2 w-full md:w-auto justify-center">
                Know More <FaArrowRight />
              </button>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}